var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"top-header"}},[_c('div',{staticClass:"center-title",on:{"click":_vm.toExternalLink}},[_c('img',{staticClass:"title-img",attrs:{"src":require("../assets/imgs/text_title.png"),"alt":"高阳地方产业数字地图"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }